
import addressIcon from 'assets/icons/icon-address@3x.png'
import timeIcon from 'assets/icons/icon-time@3x.png'

import matchDetailIcon from 'assets/icons/icon-match-detail@3x.png'

import imgBannerPrompt from 'assets/banner-prompt@3x.png'

import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'


import QuestionCell from '../Common/QuestionCell.vue'
import RoutePriceTable from '../Common/RoutePriceTable.vue'
import meiqia from '../../utils/meiqia'

import { mapActions, mapState } from 'vuex'

import routeHelper from '../../utils/route-helper.js'

export default {
name: 'RouteDetail',
components: {
XHeader,
XButton,
Card,
Previewer,
QuestionCell,
RoutePriceTable,
},
data() {
return {
addressIcon,
timeIcon,
matchDetailIcon,
imgBannerPrompt,
statusEnum: {
1: '立即预订',
2: '预订结束',
3: '售罄',
},
imgList: [],
}
},
computed: {
...mapState({
route: ({ routes }) => routes.detail,
}),
orderAble() {
return this.route && this.route.status === 1
},
submitBtnText() {
return this.statusEnum[this.route.status] || '预订结束'
},
tickets() {
return this.route.prices.map(price => ({
name: `${price.personCount}人成团`,
personCount: price.personCount,
remark: price.remark,
color: price.color,
price: price.totalPrice,
}))
},
upgradeService() {
const services = []
let conf = {}
this.route.upgradeService.forEach((service) => {
conf = {}
conf.personCount = service.personCount
service.services.forEach((config) => {
switch (config.upgradeType) {
case 1:
conf.fourStarConfig = config
break
case 3:
conf.airplaneConfig = config
break
case 4:
conf.agentConfig = config
break
default:
break
}
})
services.push(conf)
})
return services
},
fromShare() {
const url = window.location.search
if (url.indexOf('?') !== -1) {
const queryString = url.substr(1)
return queryString.split('=')[1] === 'share'
}
return false
},
},
methods: {
...mapActions(['fetchRouteDetail', 'toggleRouteFavour', 'showToast']),
getTravelType(travel) {
const travelMapping = {
1: 'dining',
2: 'hotel',
3: 'transport',
4: 'travel',
5: 'tips',
}
return travelMapping[travel.type]
},
gotoOrderConfirm() {
this.$router.push({
name: 'route-confirm',
params: this.$route.params,
})
},
generateImgList() {
const images = document.querySelectorAll('.route-detail-card img')
return Array.from(images).map(img => ({
src: img.src,
w: img.getAttribute('data-width') || 600,
h: img.getAttribute('data-height') || 400,
}))
},
getSliceIntroductions() {

return [
this.route.introductions.filter(e => e.order < 3),
this.route.introductions.filter(e => e.order >= 3),
]
},
popUpImg(event) {
if (event.target.tagName === 'IMG') {

const idx = this.imgList.map(im => im.src).indexOf(event.target.src)
this.$refs.previewer.show(idx !== -1 ? idx : 0)
}
},
initialWeixinShare() {
const { wx } = window
const { route } = this
if (wx) {
wx.ready(() => {
const shareInfo = {
title: route.name,
desc: '《观赛日》全球体育赛事门票预定',
link: window.location.href,

imgUrl: '//qncommon.saiday.com/yoyo/common/share_icon.png',
}

wx.onMenuShareAppMessage(shareInfo)
wx.onMenuShareTimeline(shareInfo)
})
}
},
addToFavour() {
if (this.$jwt.userId) {
const { routeId } = this.$route.params
this.toggleRouteFavour({ routeId, add: !this.route.isFavorite })
.then(() => {
const content = `${!this.route.isFavorite ? '收藏成功' : '已取消'}`
this.showToast({ content })
})
} else {
this.showToast({ content: '请先登录' })
routeHelper.redirectToLogin(this.$router, this.$route.path)
}
},
},
created() {
meiqia.init(this.$route.name)
const to = this.$route
document.title = '线路详情'
this.fetchRouteDetail({
routeId: to.params.routeId,
userId: this.$jwt.userId,
}).then((data) => {
this.imgList = this.generateImgList()

routeHelper.changeDocumentTitle(data.name)

this.initialWeixinShare()
}).catch((err) => {
this.showToast({
content: err.body.resultInfo,
})
setTimeout(() => {
window.history.back()
}, 1000)
})
},
}



// WEBPACK FOOTER //
// ./client/components/Route/RouteDetail.vue